import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Tabs, Tab, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  formLabelsTheme,
  iconError,
  paginationSet,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  useStylesReddit,
  validatePost,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import {
  fetchParameter,
  fetchParameter2,
  selectCountry,
  selectParameter,
  selectParameter2,
  selectPhoneType,
} from "../businessParameter/businessParameterSlice";
// MUI
import {
  makeStyles,
  fade,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { FormHelperText, InputAdornment } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { selectCountryAll } from "../location/locationSlice";
import { v4 as uuidv4 } from "uuid";
import { ModalPartiesRadio } from "./ModalPartiesRadio";
import {
  addBookingParty,
  editBookingParty,
  fetchBookingParty,
  fetchBookingVehicle,
  selectIdBooking,
} from "../booking/bookingSlice";
import {
  addOutboundParty,
  editOutboundParty,
  fetchOutboundParty,
  selectIdOutbound,
} from "./outboundSlice";
import { fetchIdParty, selectIdParty } from "../party/partySlice";
import { selectPagination } from "../../modules/Auth";
function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const ModalCreateParty = ({
  isOpen,
  setShow,
  setFormValues,
  formValues,
  setFields,
  fields,
  row,
  setRow,
  id,
  partyType,
  setPartyType,
  getParty,
  setGetParty,
  statusSave,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const dataClientRelated = useSelector(selectParameter2);
  const dataCountry = useSelector(selectCountryAll);
  const dataId = useSelector(selectIdBooking);
  const dataIdParty = useSelector(selectIdParty);
  const [showParty, setShowParty] = useState(false);
  const [get, setGet] = useState(false);
  const [tableData, setTableData] = useState([]);
  const paginationSet = useSelector(selectPagination);

  useEffect(() => {
    if (row !== null) {
      console.log("jalan");
      setFormValues({
        party_id: {
          value: row.party_id,
          error: false,
          required: "Y",
        },
        party_type: {
          value: row.party_type,
          error: false,
          required: "Y",
        },
        party: {
          value: row.party,
          error: false,
          required: "Y",
        },
        party_name: {
          value: row.party_name,
          error: false,
          required: "",
        },
        address1: {
          value: row.address1,
          error: false,
          required: "N",
        },
        address2: {
          value: row.address2,
          error: false,
          required: "N",
        },
        city: {
          value: row.city,
          error: false,
          required: "N",
        },
        zip_code: {
          value: row.zipcode,
          error: false,
          required: "N",
        },
        province: {
          value: row.province,
          error: false,
          required: "N",
        },
        country_id: {
          value: row.country_id,
          error: false,
          required: "Y",
        },
      });
    }
  }, [row]);

  useEffect(() => {
    if (formValues.party_id.value !== "") {
      dispatch(fetchIdParty(formValues.party_id.value));
    }
  }, [formValues.party_id.value]);

  useEffect(() => {
    if (dataIdParty !== null) {
      const initdata =
        dataIdParty.addresses === null
          ? []
          : dataIdParty.addresses.map((item, index) => {
              return {
                ...item,
                uuid: uuidv4(),
              };
            });
      console.log(initdata, "initdata");

      setTableData(initdata);
    }
  }, [dataIdParty]);

  console.log(tableData, "tableData");

  const partyOptions = dataClientRelated.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const countryOptions = dataCountry.map((e) => {
    return {
      value: e.country_id,
      label: e.country_name,
    };
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const handleChangeCountry = (e, params) => {
    const value = params.value;
    const label = params.label;
    setFormValues({
      ...formValues,
      ["country_id"]: {
        ...formValues["country_id"],
        value,
      },
      ["country_name"]: {
        ...formValues["country_name"],
        value: label,
      },
    });
  };

  const handleChangeParty = (e, params) => {
    const value = params.value;
    const label = params.label;
    setFormValues({
      ...formValues,
      ["party_type"]: {
        ...formValues["party_type"],
        value,
      },
    });
  };

  const handleSave = async () => {
    console.log(formValues, "formValues");
    if (!validatePost(formValues, setFormValues)) {
      return;
    }

    const params = [
      {
        booking_id: id,
        party_id: formValues.party_id.value,
        party_type: formValues.party_type.value,
        party: formValues.party.value,
        party_name: formValues.party_name.value,
        address1: formValues.address1.value,
        address2: formValues.address2.value,
        city: formValues.city.value,
        province: formValues.province.value,
        country_id: formValues.country_id.value,
        zipcode: formValues.zip_code.value,
      },
    ];

    const paramsId = [
      {
        booking_id: id,
        bookingparty_id: row === null ? "" : row.bookingparty_id,
        party_id: formValues.party_id.value,
        party_type: formValues.party_type.value,
        party: formValues.party.value,
        party_name: formValues.party_name.value,
        address1: formValues.address1.value,
        address2: formValues.address2.value,
        city: formValues.city.value,
        province: formValues.province.value,
        country_id: formValues.country_id.value,
        zipcode: formValues.zip_code.value,
      },
    ];

    console.log(params);
    console.log(paramsId);
    if (row === null) {
      try {
        const response = await dispatch(addBookingParty(params));
        console.log(response, "response");
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);

          await dispatch(
            fetchBookingParty({
              booking_id: id,
              pageNo: 1,
              pageSize: paginationSet,
            })
          );
          await handleClose();
          await window.scrollTo(0, 850);
        } else {
          await showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      try {
        const response = await dispatch(editBookingParty(paramsId));
        console.log(response, "response");
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await setShow(false);
          await dispatch(
            fetchBookingParty({
              booking_id: id,
              pageNo: 1,
              pageSize: paginationSet,
            })
          );
          await window.scrollTo(0, 850);
        } else {
          await showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    }
  };

  const handleSaveOutbound = async () => {
    console.log(formValues, "formValues");
    if (!validatePost(formValues, setFormValues)) {
      return;
    }

    const params = [
      {
        outbound_id: id,
        party_id: formValues.party_id.value,
        party_type: formValues.party_type.value,
        party: formValues.party.value,
        party_name: formValues.party_name.value,
        address1: formValues.address1.value,
        address2: formValues.address2.value,
        city: formValues.city.value,
        province: formValues.province.value,
        country_id: formValues.country_id.value,
        zip_code: formValues.zip_code.value,
      },
    ];

    const paramsId = [
      {
        outboundcarrier_id: row === null ? "" : row.outboundcarrier_id,
        party_id: formValues.party_id.value,
        party_type: formValues.party_type.value,
        party: formValues.party.value,
        party_name: formValues.party_name.value,
        address1: formValues.address1.value,
        address2: formValues.address2.value,
        city: formValues.city.value,
        province: formValues.province.value,
        country_id: formValues.country_id.value,
        zip_code: formValues.zip_code.value,
      },
    ];
    if (row === null) {
      try {
        const response = await dispatch(addOutboundParty(params));
        console.log(response, "response");
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);

          await dispatch(
            fetchOutboundParty({
              outbound_id: id,
              pageNo: 1,
              pageSize: paginationSet,
            })
          );
          await handleClose();
          await window.scrollTo(0, 850);
        } else {
          await showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      console.log("else");

      try {
        const response = await dispatch(editOutboundParty(paramsId));
        console.log(response, "response");
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await dispatch(
            fetchOutboundParty({
              outbound_id: id,
              pageNo: 1,
              pageSize: paginationSet,
            })
          );
          await handleClose();
          await window.scrollTo(0, 850);
        } else {
          await showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    }
  };

  const indexParty = partyOptions.findIndex(
    (obj) => obj.value === formValues.party_type.value
  );

  const indexCountry = countryOptions.findIndex(
    (obj) => obj.value === formValues.country_id.value
  );

  const handleClose = () => {
    setFormValues({
      ...formValues,
      party_id: {
        value: "",
        error: false,
        required: "N",
      },
      party_type: {
        value: "",
        error: false,
        required: "Y",
      },
      party: {
        value: "",
        error: false,
        required: "Y",
      },
      party_name: {
        value: "",
        error: false,
        required: "",
      },
      address1: {
        value: "",
        error: false,
        required: "N",
      },
      address2: {
        value: "",
        error: false,
        required: "N",
      },
      city: {
        value: "",
        error: false,
        required: "N",
      },
      zip_code: {
        value: "",
        error: false,
        required: "N",
      },
      province: {
        value: "",
        error: false,
        required: "N",
      },
      country_id: {
        value: "",
        error: false,
        required: "Y",
      },
    });
    setRow(null);
    setShow(false);
  };

  const [showAddress, setShowAddress] = useState(false);

  const handleSubmit = () => {
    if (selected === null) {
      return showDialog("Please Select ...");
    }
    setFormValues({
      ...formValues,
      address1: {
        value: selected.address1,
        error: false,
        required: "N",
      },
      address2: {
        value: selected.address2,
        error: false,
        required: "N",
      },
      city: {
        value: selected.city,
        error: false,
        required: "N",
      },
      zip_code: {
        value: selected.zipcode,
        error: false,
        required: "N",
      },
      province: {
        value: selected.province,
        error: false,
        required: "N",
      },
      country_id: {
        value: selected.country_id,
        error: false,
        required: "Y",
      },
    });
    setShowAddress(false);
  };
  const [selected, setSelected] = useState(null);

  const selectRow = {
    mode: "radio",
    clickToSelect: true,
    onSelect: (row, isSelect, rowIndex, e) => {
      setSelected(row);
    },
  };

  const columns = [
    {
      text: "Address Type",
      dataField: "addresstype__name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Address Line 1",
      dataField: "address1",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Address Line 2",
      dataField: "address2",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Zip Code",
      dataField: "zipcode",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "City",
      dataField: "city",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Province",
      dataField: "province",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Country",
      dataField: "country_name",
      style: { minWidth: "60px" },
      headerAlign: "center",
    },
  ];

  return (
    <>
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={isOpen}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            {row === null ? "Add" : "Update"} Party
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ThemeProvider theme={formLabelsTheme}>
            <Row>
              <Col xs={12} sm={3} md={6} lg={6}>
                <Autocomplete
                  disablePortal
                  name="party_type"
                  options={partyOptions}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  // disableClearable={true}i
                  value={
                    partyOptions.find(
                      (option) => option.value === formValues.party_type.value
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    if (newValue === null) {
                      setFormValues({
                        ...formValues,
                        ["party_type"]: {
                          ...formValues["party_type"],
                          value: "",
                        },
                        ["party"]: {
                          ...formValues["party"],
                          value: "",
                        },
                        ["party_id"]: {
                          ...formValues["party_id"],
                          value: "",
                        },
                        ["party_name"]: {
                          ...formValues["party_name"],
                          value: "",
                        },
                      });
                    } else {
                      setFormValues({
                        ...formValues,
                        ["party_type"]: {
                          ...formValues["party_type"],
                          value: newValue.value,
                        },
                        ["party"]: {
                          ...formValues["party"],
                          value: "",
                        },
                        ["party_id"]: {
                          ...formValues["party_id"],
                          value: "",
                        },
                        ["party_name"]: {
                          ...formValues["party_name"],
                          value: "",
                        },
                      });
                    }
                  }}
                  renderInput={(params) => (
                    <RedditTextField
                      required
                      className={classes.margin}
                      {...params}
                      label="Party Type"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      placeholder="Select"
                      name="party_type"
                      error={formValues.party_type.error}
                      helperText={
                        formValues.party_type.error ? (
                          <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                            {iconError} {"This field is required"}
                          </FormHelperText>
                        ) : (
                          ""
                        )
                      }
                    />
                  )}
                />

                <Row>
                  <Col xs={10} sm={3} md={9} lg={9}>
                    <RedditTextField
                      required
                      label="Party"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      value={formValues.party.value}
                      error={formValues.party.error}
                      helperText={
                        formValues.party.error ? (
                          <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                            {iconError} {"This field is required"}
                          </FormHelperText>
                        ) : (
                          ""
                        )
                      }
                    />
                  </Col>
                  <Col xs={1} sm={1} md={1} lg={1}>
                    <div>
                      <a
                        className={`display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5 ${
                          formValues.party_type.value === "" ? "disabled" : ""
                        } `}
                      >
                        <span
                          className="svg-icon svg-icon-md svg-icon-light"
                          onClick={() => {
                            setGet(true);
                            setShowParty(true);
                          }}
                        >
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/New/Search.svg"
                            )}
                          />
                        </span>
                      </a>
                    </div>
                  </Col>
                  {formValues.party.value !== "" && (
                    <div
                      className="ml-5"
                      style={{ marginTop: "22px", cursor: "pointer" }}
                      onClick={() => {
                        setFormValues({
                          ...formValues,
                          party_id: {
                            value: "",
                            error: false,
                            required: "Y",
                          },
                          party_name: {
                            value: "",
                            error: false,
                            required: "N",
                          },
                          party: {
                            value: "",
                            error: false,
                            required: "N",
                          },
                        });
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/New/x-square.svg"
                          )}
                        />
                      </span>
                    </div>
                  )}
                </Row>
              </Col>
              <Col xs={12} sm={3} md={6} lg={6}>
                {" "}
                <RedditTextField
                  label="Party Name"
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  fullWidth
                  name="party_name"
                  onChange={handleChange}
                  value={formValues.party_name.value}
                />
              </Col>
            </Row>
            <p className="font-weight-bold  m-3">Address Details :</p>
            <Row className="justify-content-end">
              <Button
                variant="primary"
                onClick={(e) => {
                  setShowAddress(true);
                }}
              >
                Select Address
              </Button>
            </Row>
            <Row>
              <Col xs={12} sm={3} md={6} lg={6}>
                <RedditTextField
                  label="Address Line 1"
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  fullWidth
                  multiline
                  rows="4"
                  name="address1"
                  onChange={handleChange}
                  value={formValues.address1.value}
                />
                <RedditTextField
                  label="City"
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  fullWidth
                  name="city"
                  onChange={handleChange}
                  value={formValues.city.value}
                />
                <RedditTextField
                  label="Province"
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  fullWidth
                  name="province"
                  onChange={handleChange}
                  value={formValues.province.value}
                />
              </Col>
              <Col xs={12} sm={3} md={6} lg={6}>
                <RedditTextField
                  label="Address Line 2"
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  fullWidth
                  multiline
                  rows="4"
                  name="address2"
                  onChange={handleChange}
                  value={formValues.address2.value}
                />
                <RedditTextField
                  label="Zip Code"
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  size="small"
                  type="number"
                  fullWidth
                  name="zip_code"
                  onChange={handleChange}
                  value={formValues.zip_code.value}
                />
                <Autocomplete
                  disablePortal
                  name="Country"
                  options={countryOptions}
                  getOptionLabel={(option) => option.label.toString()}
                  disableClearable={true}
                  onChange={handleChangeCountry}
                  value={
                    countryOptions.find(
                      (option) => option.value === formValues.country_id.value
                    ) || null
                  }
                  renderInput={(params) => (
                    <RedditTextField
                      required
                      className={classes.margin}
                      {...params}
                      label="Country"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      placeholder="Select"
                      name="country_id"
                      error={formValues.country_id.error}
                      helperText={
                        formValues.country_id.error ? (
                          <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                            {iconError} {"This field is required"}
                          </FormHelperText>
                        ) : (
                          ""
                        )
                      }
                    />
                  )}
                />
              </Col>
            </Row>
          </ThemeProvider>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {statusSave === true && (
            <Button
              onClick={() => {
                if (partyType === "Outbound") {
                  handleSaveOutbound();
                } else {
                  handleSave();
                }
              }}
              variant="primary"
            >
              Save
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <ModalPartiesRadio
        isOpen={showParty}
        setShow={setShowParty}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFields}
        fields={fields}
        get={get}
        setGet={setGet}
      />
      {/* select address */}
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showAddress}
        onHide={(e) => setShowAddress(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            Select Address
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <BootstrapTable
            wrapperClasses="table-responsive"
            classes="table table-head-custom table-vertical-center overflow-hidden"
            bootstrap4
            keyField="partyaddr_id"
            data={tableData}
            columns={columns}
            selectRow={selectRow}
            hover
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={(e) => setShowAddress(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
